import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {MinusIcon} from "../../appearence/icons/minus_icon";
import {preferenceSaveService} from "../../services/preferenceSaveService";
import { Input } from '@chapche/ui';

function capitalizeFirstLetter(phrase: string): string {
    if (phrase === "") return "";
    return phrase.charAt(0).toUpperCase() + phrase.slice(1);
}

export const PreferenceStructurePhraseItem = ({phrase, handleAddPhrase, handleDeletePhrase}) => {
    const { i18n } = useTranslation();
    const [phraseContent, setPhraseContent] = useState<string>("");
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [phraseId, setPhraseId] = useState<string>(null);

    useEffect(() => {
        setPhraseContent(phrase.content);
        setIsSaving(false);
        setPhraseId(phrase.id);
    }, [phrase]);

    const handlePhraseContent = (e) => {
        const currentPhrase = e.target.value;
        setPhraseContent(currentPhrase);
        if (isSaving) {
            return;
        }
        if (!phraseId) {
            setIsSaving(true);
            preferenceSaveService.savePhrase(null, {
                content: currentPhrase,
                locale: i18n.resolvedLanguage,
            }, (newId) => {
                setIsSaving(false);
                setPhraseId(newId);
                handleAddPhrase(currentPhrase, newId);
                preferenceSaveService.updatePreferencePhrases(currentPhrase, phraseId);
                preferenceSaveService.savePhrase(newId);
            });
        } else {
            preferenceSaveService.updatePreferencePhrases(currentPhrase, phraseId);
            preferenceSaveService.savePhrase(phraseId);
        }
    };

    return (
        <p className='preference__form-block'>
            <Input
                fullWidth
                className={`mt-0 ${phraseContent ? 'preference__form-input_filled' : ''}`}
                placeholder={capitalizeFirstLetter(i18n.t('app.page.preference.enterPhrase'))}
                onChange={handlePhraseContent}
                value={capitalizeFirstLetter(phraseContent)}/>
            {phraseId ?
                <span onClick={() => handleDeletePhrase(phraseId)}>
                    <MinusIcon nameOfClass="preference__form-icon" />
                </span>
                :
                null}
        </p>
    );
};
